import { useEffect } from "react"
import { useSignal } from "@preact/signals-react"
import { isEmpty, postSubmit } from "@ui-seeker/utils"

import { WEBBACK_V2_API } from "@constants"
import { useToast } from "@hooks"
import { adminScrapingDataReviewDetails } from "../@signals"


export default function useAdminScrapingDataReviewDetails() {
	const { showToast } = useToast()

	const data = useSignal({})
	const isLoading = useSignal(false)

	useEffect(() => {
		if (isEmpty(adminScrapingDataReviewDetails.value)) {
			data.value = {}
			return
		}
		// `scraping-data-review/show-details` (v2): el texto de la ficha y las galerías ya no
		// viajan dentro de cada fila de la tabla. En v1 iban pegados a `ITEM_RAW`; aquí el texto
		// vive en una satélite InnoDB que solo se lee por PK y la multimedia está normalizada,
		// así que se piden al abrir el drawer — 2,39 MB de texto y 1,5 MB de URLs que antes se
		// mandaban para nada. Mismo patrón que Product Page Details.
		isLoading.value = true
		postSubmit(`${WEBBACK_V2_API}/admin/scraping-data-review/show-details`, {
			productID: adminScrapingDataReviewDetails.value.productID,
			date: adminScrapingDataReviewDetails.value.date,
			retailer: [adminScrapingDataReviewDetails.value.siteID]
		}).then(res => {
			data.value = res
		}).catch(() => {
			showToast.error()
			data.value = {}
		}).finally(() => isLoading.value = false)
	}, [JSON.stringify(adminScrapingDataReviewDetails.value)])

	return { detailsData: data.value, isLoadingDetails: isLoading.value }
}
